import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import "rxjs";
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from "rxjs/BehaviorSubject"
import 'rxjs/add/operator/map';
import * as _ from "lodash";

import { Constants } from '../../../../../app.constant';
import { Content } from '../models/media-content';
import { HttpService } from '../../../../../services/http.service';
import { FileUploader } from "ng2-file-upload";

@Injectable()

export class MediaLibraryServices extends HttpService {

  public contentInfo = <Content>{};
  public filterBy = new Subject();
  // public subject = new Subject();
  public filteredContent;
  public uploadedMedia;
  public bulkUploadMedia;
  public fileUploadConfirmation = new Subject<any>();
  //protected URL = Constants.Var.BASE_URL+"/addcontent";
  protected URL = Constants.Var.BASE_URL + "/content/file";
  public timeOutConfig = Constants.CurrentConfigInformations('timeOutSpecificForSomeApis');

  setContentInformations(res: any): any {
    this.contentInfo = res;
  }
  getContentInformations(): any {
    return this.contentInfo;
  }

  // sendContentData(data: any) {
  //   this.subject.next(data);
  //   this.bulkUploadMedia = data;
  // }

  // getContentData(): Observable<any> {
  //   return this.subject.asObservable();
  // }

  sendFileUploadConfirmation(data: any) {
    this.fileUploadConfirmation.next(data);
    this.uploadedMedia = data;
  }

  getFileUploadConfirmation(): Observable<any> {
    return this.fileUploadConfirmation.asObservable();
  }

  getContentTypes(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/contentTypes', requestOptionsArgs, 'content')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getSupportedFormats(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/content/supported-formats', requestOptionsArgs, 'content')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getUploadedContent(): Observable<any> {
    let requestOptionsArgs = {};
    /*_.forEach(this.timeOutConfig,(config) =>{
      if(config.id == 1){
        this.redirectTime=config.timeOutTimeInMin;
        
      }
    })*/
    this.countDelayedResponse(0);
    return this.getApi('/content', requestOptionsArgs, 'uploaded-content')
      .map(res => res.json())
      .do(
        data => {
          if (this.timerArr.length) {
            this.clearAllInterval();
          }
        }
      )
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getResolverData = function (params: any): Observable<any> {
    params = _.assignIn({}, params);
    let requestOptionsArgs = { search: params };
    return this.getApi('/content', requestOptionsArgs, 'content-list')
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getAllMedia(params: any): Observable<any> {
    params = _.assignIn({}, params);
    /*_.forEach(this.timeOutConfig,(config) =>{
      if(config.id == 1){
        this.redirectTime=config.timeOutTimeInMin;
        
      }
    })*/
    this.countDelayedResponse(0);
    let requestOptionsArgs = { search: params };
    return this.getApi('/content', requestOptionsArgs, 'content-list')
      .map(res => {
        return res.json() && res.json().result;

      })
      .do(
        data => {
          if (this.timerArr.length) {
            this.clearAllInterval();
          }
        }
      )
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getArchivedMedia(params: any): Observable<any> {
    params = _.assignIn({}, params);
    this.countDelayedResponse(0);
    let requestOptionsArgs = { search: params };
    return this.getApi('/content/archive', requestOptionsArgs, 'content-archive')
      .map(res => {
        return res.json() && res.json().result;

      })
      .do(
        data => {
          if (this.timerArr.length) {
            this.clearAllInterval();
          }
        }
      )
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  addMedia(mediaData: any): Observable<boolean> {
    console.log('mediaData=>',mediaData)
    let requestOptionsArgs = { body: mediaData };
    /*_.forEach(this.timeOutConfig,(config) =>{
      if(config.id == 1){
        this.redirectTime=config.timeOutTimeInMin;
        
      }
    })*/
    return this.postApi('/content', requestOptionsArgs, 'register')
      .map(res => {
        // return true to indicate successful login
        return true;
      })
      .do(
        data => {
          if (this.timerArr.length) {
            this.clearAllInterval();
          }
        }
      )
      .catch((e) => Observable.throw(this.errorHandler(e)));

  }
  updateMedia(mediaData: any): Observable<boolean> {
    let requestOptionsArgs = { body: mediaData };
    /*_.forEach(this.timeOutConfig,(config) =>{
      if(config.id == 1){
        this.redirectTime=config.timeOutTimeInMin;
        
      }
    })*/
    return this.putApi('/content', requestOptionsArgs, 'register')
      .map(res => {
        // return true to indicate successful login
        return true;
      })
      .do(
        data => {
          if (this.timerArr.length) {
            this.clearAllInterval();
          }
        }
      )
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  fileUpload(authToken, customerId) {
    let res: FileUploader;
    res = new FileUploader({
      url: this.URL,
      authToken: authToken,
      customerId: customerId,
      disableMultipart: true,
      formatDataFunctionIsAsync: false,
      formatDataFunction: async (item) => {
        return new Promise((resolve, reject) => {
          resolve({
            name: item._file.name,
            length: item._file.size,
            contentType: item._file.type,
            date: new Date()
          });
        });
      }
    });

    return res;
  }

  updateContent(mediaData: object): Observable<boolean> {
    mediaData = _.assignIn({}, mediaData);

    let requestOptionsArgs = { body: mediaData };
    return this.putApi(`/content/${mediaData['contentId']}`, requestOptionsArgs, 'register')
      .map(res => {
        // return true to indicate successful login
        return true;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  deleteContent(contentIds: any): Observable<boolean> {
    let requestOptionsArgs = new RequestOptions({ body: { 'ids': contentIds } });
    //let requestOptionsArgs = new RequestOptions({ body:  contentIds });
    //let requestOptionsArgs={};
    return this.deleteApi('/content', requestOptionsArgs, 'remove-campaign')
      //return this.deleteApi('/content/'+contentIds, requestOptionsArgs, 'deleteUser')
      .map(res => {
        this.response = res.json() && res.json().result;
        return this.response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getMediaById(contentId: number): Observable<any> {
    //let requestOptionsArgs = new RequestOptions({ body: { 'contentId': contentId } });
    let requestOptionsArgs = {};
    return this.getApi('/content/' + contentId, requestOptionsArgs, 'content-list', false, 2)
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getAllMediaByAdvanceSearch(searchParam: any): Observable<any> {
    /*_.forEach(this.timeOutConfig,(config) =>{
      if(config.id == 1){
        this.redirectTime=config.timeOutTimeInMin;
        
      }
    })*/
    this.countDelayedResponse(0);
    const optionals = Constants.setParamsObject(searchParam);
    let searchQuery: any;
    let query = optionals.split('=')
    if (query[1] != '%7B%7D') {
      searchQuery = optionals;
    } else {
      searchQuery = '';
    }
    let requestOptionsArgs = {};
    return this.getApi('/content' + searchQuery, requestOptionsArgs, 'content-list')
      .map(res => {
        return res.json() && res.json();

      })
      .do(
        data => {
          if (this.timerArr.length) {
            this.clearAllInterval();
          }
        }
      )
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getWidgetByType(widgetType: string): Observable<any> {
    return this.getWidgets().map(widgetContents => {
      return _.find(widgetContents, { widgetType: widgetType });
    });
  }

  getWidgets(): Observable<any> {
    return Observable.of(_.cloneDeep(Constants.getWidgetsSampleObject()));
  }

  getTags(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/contentTags', requestOptionsArgs, 'tag-list', false)
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  public downloadFile(url: string) {
    let token = Constants.userAuthorisedToken();
    let customerId = Constants.CurrentCustomerInfomations('customerId');
    let head = { 'Content-Type': 'application/json' };
    if (token) {
      head['Authorization'] = `Bearer ${token}`;

    }
    if (customerId) {
      head['customerId'] = customerId;

    }

    let headers = new Headers(head);
    var requestOptionsArgs = new RequestOptions({ headers: headers });
    return this.fileDownloadApi(`${url}`, requestOptionsArgs, 'url')
      .map(res => res.json()).subscribe(
        (data: any) => {

        },

        () => {
          // window.open(`${url}`);

        });

  }

  archiveContent(mediaData: any, type?): Observable<boolean> {
    // console.log('mediaData=>',mediaData)
    let requestOptionsArgs = { body: mediaData };
    /*_.forEach(this.timeOutConfig,(config) =>{
      if(config.id == 1){
        this.redirectTime=config.timeOutTimeInMin;
        
      }
    })*/
    let url = type == 'unarchive' ? '/content/unarchive' : '/content/archive';
    return this.postApi(url, requestOptionsArgs, 'content-archive')
      .map(res => {
        // return true to indicate successful login
        return true;
      })
      .do(
        data => {
          if (this.timerArr.length) {
            this.clearAllInterval();
          }
        }
      )
      .catch((e) => Observable.throw(this.errorHandler(e)));

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/cms/components/media-library/services/mediaLibraryServices.ts